<div class="novo-cliente-filter" [formGroup]="quickForm">
  <!-- Filtros Rápidos -->
  <div class="novo-cliente-filter__quick">
    <div class="novo-cliente-filter__quick-block">
      <!-- Pesquisa -->
      <div class="novo-cliente-filter__pesquisa">
        <i class="fas fa-search novo-cliente-filter__pesquisa-icon"></i>
        <input
          type="text"
          class="form-control novo-cliente-filter__pesquisa-input"
          formControlName="filterPsq"
          placeholder="Pesquise por código, nome ou CNPJ/CPF"
        />
        <button
          *ngIf="quickForm.get('filterPsq').value"
          type="button"
          class="novo-cliente-filter__pesquisa-clear"
          (click)="clearSearch()"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Cadastros -->
      <div class="novo-cliente-filter__multiselect-item">
        <sgt-novo-cliente-cadastro-multi-select
          formControlName="cadastros"
          variante="filtro"
          (idsCadastrosChange)="onChangeCadastros($event)"
        >
        </sgt-novo-cliente-cadastro-multi-select>
      </div>

      <!-- Situações -->
      <div class="novo-cliente-filter__multiselect-item">
        <sgt-novo-cliente-situacao-multi-select
          formControlName="situacoes"
          variante="filtro"
          [settings]="{
            placeholder: 'Situações',
            singular: 'Situação',
            plural: 'Situações',
            searchEmptyResultMessage: 'Nenhuma situação encontrada',
            showFooter: true
          }"
          (changed)="onChangeSituacoes($event)"
        >
        </sgt-novo-cliente-situacao-multi-select>
      </div>

      <!-- Segmentos -->
      <div class="novo-cliente-filter__multiselect-item">
        <sgt-segmentos-multi-select
          formControlName="idsClassificacoes"
          [segmento]="tipoSegmento.CLIENTE"
          [settings]="{
            placeholder: 'Segmentos',
            singular: 'Segmento',
            plural: 'Segmentos',
            searchEmptyResultMessage: 'Nenhum segmento encontrado',
            showFooter: true
          }"
          variante="filtro"
          (changed)="onChangeSegmentos($event)"
        >
        </sgt-segmentos-multi-select>
      </div>

      <!-- Tags -->
      <div class="novo-cliente-filter__multiselect-item">
        <sgt-tags-multi-select
          formControlName="idsTags"
          [cadastros]="isCadastroItem"
          [situacoes]="situacao"
          variante="filtro"
          [settings]="{
            placeholder: 'Tags',
            searchEmptyResultMessage: 'Nenhuma tag encontrada',
            plural: 'Tags',
            singular: 'Tag',
            showFooter: true
          }"
          (changed)="onChangeTags($event)"
        >
        </sgt-tags-multi-select>
      </div>

      <!-- Representantes -->
      <div class="novo-cliente-filter__multiselect-item" *ngIf="!isRepresentante">
        <sgt-novo-representante-multi-select
          formControlName="idsRepresentantes"
          variante="filtro"
          (search)="onChangeRepresentantes($event)"
        >
        </sgt-novo-representante-multi-select>
      </div>

      <!-- Ações -->
      <div class="novo-cliente-filter__actions">
        <button
          type="button"
          class="btn btn-light"
          (click)="refresh()"
          sgtTooltip="Atualizar listagem"
          aria-label="Atualizar listagem"
        >
          <i class="fas fa-sync-alt" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="btn btn-light novo-cliente-filter__btn-filtros"
          (click)="openAdvancedFilterModal()"
          sgtTooltip="Filtros avançados"
          aria-label="Filtros avançados"
        >
          <i class="fas fa-filter" aria-hidden="true"></i>
          <span
            *ngIf="advancedFilterCount > 0"
            class="badge badge-primary ml-1"
          >{{ advancedFilterCount }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<sgt-novo-cliente-filter-avancado
  [isOpen]="isAdvancedFilterModalOpen"
  [idsRepresentantes]="idsRepresentantes"
  [initialValue]="advancedForm"
  (apply)="onAdvancedFilterApply($event)"
  (cleared)="onAdvancedFilterCleared()"
  (closed)="onAdvancedFilterClosed()"
>
</sgt-novo-cliente-filter-avancado>
